export default __webpack_public_path__ + "static/media/CoinFlipAnimation.df5beca6.gif";